var _dec, _dec2, _dec3, _dec4, _dec5, _class, _class2, _descriptor, _descriptor2;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
/*!
 * @copyright
 * Copyright(c) 2021 SICK AG
 */
import { Component, CustomElement, html, Prop } from '@sick-davinci/ce-decorators';
import { style } from './HeaderPopdown.style';
import { Popout } from '../../popout/Popout';

/**
 * The `davinci-core-header-popdown` generates a popdown dedicated to bind content to a button in
 * a davinci-core-header or davinci-core-header2.
 * It automatically registers click-handlers on the target-element, that will toggle the popdown open/close.
 * It positions itself below the target-elementand aligns the center of the tip to the middle of the bound element.
 *
 * @example
 * ```html
 * <button id="ButtonID">open popdown</button>
 * <davinci-core-header-popdown autoclose target="#ButtonID">
 *  <h1>My Content</h1>
 *  <p>Some more text ...</p>
 * </davinci-core-header-popdown>
 * ```
 */
export let HeaderPopdown = (_dec = Component({
  style: [style],
  tag: 'davinci-core-header-popdown',
  dependencies: [Popout]
}), _dec2 = Prop({
  type: String
}), _dec3 = Reflect.metadata("design:type", Object), _dec4 = Prop({
  type: Boolean
}), _dec5 = Reflect.metadata("design:type", Boolean), _dec(_class = (_class2 = class HeaderPopdown extends CustomElement {
  constructor(...args) {
    super(...args);
    /**
     * Specifies to which Element the popdown should link itself.
     * If not set, the Popdown will render in the top right of the currenty visible part of the viewport.
     * You can pass either an element reference (only via property) or a queryselector.
     * The queryselector only works in the light-dom and will not pierce into shadow-dom!
     */
    _initializerDefineProperty(this, "target", _descriptor, this);
    /**
     * Reflects, if the popdown is visible, or not.
     */
    _initializerDefineProperty(this, "open", _descriptor2, this);
  }
  render() {
    return html`
      <davinci-popout
        alt-direction
        side="bottom"
        .target="${this.target}"
        .open="${this.open}"
        @open="${e => {
      this.open = e.detail;
    }}"
      >
        <slot></slot>
      </davinci-popout>
    `;
  }
}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "target", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "open", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
})), _class2)) || _class);
